import React from 'react';
import styles from './TabBar.module.scss';
import classNames from 'classnames';

export const tabBarVariants = {
  full: 'full',
  pill: 'pill',
  underline: 'underline',
};
// 'md' (default) keeps every existing caller pixel-identical; 'sm' is a
// more compact density for tabs sitting inside an already-small card
// (e.g. a table header) rather than as a page's primary navigation.
export const tabBarSizes = {
  md: 'md',
  sm: 'sm',
};
export const TabBarComponent = ({
  tabs,
  activeTab,
  onTabClick,
  variant,
  size = tabBarSizes.md,
  className,
}) => {
  const handleTabClick = (tab) => {
    if (activeTab === tab) return;
    onTabClick?.(tab);
  };
  return (
    <div
      className={classNames(
        styles.tabBar,
        {
          [styles.tabBar_pill]: variant === tabBarVariants.pill,
          [styles.tabBar_underline]: variant === tabBarVariants.underline,
          [styles.tabBar_sm]: size === tabBarSizes.sm,
        },
        className
      )}
    >
      {tabs?.map((tab, index) => {
        const isActive = activeTab === tab?.value;
        return (
          <div
            key={index}
            className={classNames(styles.tab, {
              [styles.tab_active]: isActive,
              [styles.tab_full]: variant === tabBarVariants.full,
              [styles.tab_active_full]:
                variant === tabBarVariants.full && isActive,
              [styles.tab_pill]: variant === tabBarVariants.pill,
              [styles.tab_active_pill]:
                variant === tabBarVariants.pill && isActive,
              [styles.tab_underline]: variant === tabBarVariants.underline,
              [styles.tab_active_underline]:
                variant === tabBarVariants.underline && isActive,
              [styles.tab_sm]: size === tabBarSizes.sm,
            })}
            onClick={() => handleTabClick(tab?.value)}
          >
            {tab?.icon}
            {tab?.label}
            {tab?.count != null && (
              <span className={styles.tabCount}>{tab.count}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};
